var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ci-hamburger",class:{
		'is-active': _vm.value
	},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"fas fa-bars"})])}
var staticRenderFns = []

export { render, staticRenderFns }